<div class="card card-tabs">
	<div class="card-body">
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<label for="" class="title">
				Graficas
			</label>
			<input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="0" checked id="tab0">
			<label for="tab0">
				<i class="fa fa-table-cells"></i> Mapa de Calor (Venta)
			</label>
			<input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="1" id="tab1">
			<label for="tab1">
				<i class="fa fa-link"></i> Mapa de Calor (Compra)
			</label>
			<input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="2" id="tab2">
			<label for="tab2">
				<i class="fa fa-link"></i> Asociados
			</label>
			<input type="radio" [(ngModel)]="tab" name="pcss3t" [value]="3" id="tab3">
			<label for="tab3">
				<i class="fa fa-calendar"></i> Calendario
			</label>
		</div>
		<app-heat-map-sales *ngIf="tab == 0"></app-heat-map-sales>
		<app-heat-map-outcome *ngIf="tab == 1"></app-heat-map-outcome>
		<app-associated-products-report *ngIf="tab == 2"></app-associated-products-report>
		<app-order-purchase-calendar-report *ngIf="tab == 3"></app-order-purchase-calendar-report>
	</div>
</div>